import { Locale } from 'modules/i18n';

export const bannerTranslation = {
  [Locale.en]: {
    text: 'Effective April 14, Polygon, Rollux, and Syscoin will join <a href={href} target="_blank">other chains</a> that require users to sign in on the platform to access their APIs.',
  },
};
